<script>
	import { onMount } from 'svelte';
	import Reader from './reader.svelte';
	import Home from './home.svelte';

	let route = { name: 'home', path: '' };

	setTimeout(() => { greeting = true }, 8400);
	setTimeout(() => { greeting = false }, 21000);

	function parseHash() {
		const raw = location.hash.replace(/^#\/?/, '');
		if (!raw) return { name: 'home', path: '' };
		const parts = raw.split('/');
		if (parts[0] === 'moe') {
			const path = parts.slice(1).join('/');
			return { name: 'moe', path: path || '' };
		}
		return { name: 'home', path: '' };
	}

	function updateRouteFromHash() {
		route = parseHash();
	}

	onMount(() => {
		updateRouteFromHash();
		window.addEventListener('hashchange', updateRouteFromHash);
		return () => window.removeEventListener('hashchange', updateRouteFromHash);
	});
</script>

{#if route.name !== "home"}
	<nav class="top">
		<a href="#/">home</a>
		<a href="#/moe">moe</a>
	</nav>
{/if}

{#if route.name === 'moe'}
	<Reader routePath={route.path} />
{:else}
	<Home />
{/if}

<style>
.top {
	display: flex;
	gap: 16px;
	margin-bottom: 18px;
}
.top a {
	text-decoration: none;
}
</style>